/* Muravai offer landing (sections/muravai-offer-landing.liquid).
   Tier prices come from the product's price in the visitor's market (or a text override);
   the cart gets the paid units only and EG Auto Add to Cart adds the free units and gifts. */

(function () {
  'use strict';

  document.querySelectorAll('[data-muravai-lp]').forEach(init);
  document.querySelectorAll('[data-muravai-lp-banner] [data-countdown]').forEach(initCountdown);
  // Banner cart button: the store header is hidden here, so open its cart drawer directly.
  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest('[data-lp-open-cart]')) return;
    window.dispatchEvent(new CustomEvent('muravai:open-cart'));
  });
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-muravai-lp]').forEach(init);
    document.querySelectorAll('[data-muravai-lp-banner] [data-countdown]').forEach(initCountdown);
  });

  function init(root) {
    var showerheadVariant = root.getAttribute('data-variant-id');
    var addonVariant = root.getAttribute('data-addon-variant');
    var addonPlan = root.getAttribute('data-addon-plan');
    var onceVariant = root.getAttribute('data-once-variant');
    var onceOnly = root.querySelectorAll('[data-once-only]');
    var autoshipNote = root.querySelector('[data-autoship-only]');
    var onceMode = false;
    var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart.js';

    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-bundle]'));
    var variantRows = Array.prototype.slice.call(root.querySelectorAll('[data-variant-row]'));
    var gifts = root.querySelectorAll('[data-gift]');
    var submit = root.querySelector('[data-submit]');
    var tryOnce = root.querySelector('[data-try-once]');
    var hint = root.querySelector('[data-variant-hint]');
    var status = root.querySelector('[data-status]');
    var submitLabel = submit ? submit.textContent : '';
    var variantQty = {};
    var busy = false;

    initFilterAccordion(root);
    initMarquee(root);
    initCompareSlider(root);
    initStatRings(root);

    function selectedBundle() {
      return bundles.filter(function (b) { return b.classList.contains('is-selected'); })[0] || bundles[0];
    }

    function bundleQuantity() {
      var bundle = selectedBundle();
      return bundle ? Math.max(1, Number(bundle.getAttribute('data-quantity')) || 1) : 1;
    }

    // Units actually added to the cart; EG Auto Add to Cart adds the free ones.
    function cartQuantity() {
      var bundle = selectedBundle();
      if (!bundle) return 1;
      return Math.max(1, Number(bundle.getAttribute('data-cart-quantity')) || bundleQuantity());
    }

    function chosenTotal() {
      return Object.keys(variantQty).reduce(function (sum, id) { return sum + variantQty[id]; }, 0);
    }

    function render() {
      var qty = bundleQuantity();
      var bundle = selectedBundle();

      gifts.forEach(function (gift) {
        var rule = gift.getAttribute('data-gift-rule');
        var count = rule === 'per_unit' ? qty : rule === 'per_unit_minus_one' ? Math.max(1, qty - 1) : rule === 'per_paid_unit' ? Math.max(1, Math.ceil(qty / 2)) : 1;
        var label = gift.querySelector('[data-gift-qty]');
        var badge = gift.querySelector('[data-gift-count]');
        if (label) label.textContent = rule === 'none' || gift.hasAttribute('data-gift-hide-label') ? '' : count + '× ';
        if (badge) {
          badge.textContent = count + '×';
          badge.hidden = rule === 'none' || count < 2;
        }
      });

      if (onceMode) {
        if (submit && !busy) {
          submit.classList.remove('is-pending');
          submit.textContent = submit.getAttribute('data-once-cta') || submitLabel;
        }
        return;
      }

      if (variantRows.length) {
        var total = chosenTotal();
        var remaining = qty - total;
        variantRows.forEach(function (row) {
          var id = row.getAttribute('data-variant-id');
          var q = variantQty[id] || 0;
          var control = row.querySelector('[data-variant-control]');
          if (!control) return;
          var display = row.querySelector('[data-variant-qty]');
          var inc = row.querySelector('[data-variant-increase]');
          var dec = row.querySelector('[data-variant-decrease]');
          var add = row.querySelector('[data-variant-add]');
          var active = q > 0;
          control.classList.toggle('is-active', active);
          row.classList.toggle('is-in-cart', active);
          control.querySelector('.muravai-lp__qty-selector').setAttribute('aria-hidden', active ? 'false' : 'true');
          display.textContent = String(q);
          inc.tabIndex = dec.tabIndex = active ? 0 : -1;
          inc.disabled = remaining <= 0;
          add.disabled = remaining <= 0;
        });
        if (hint) {
          hint.textContent = remaining > 0
            ? 'Choose ' + remaining + ' more (' + total + ' of ' + qty + ' selected)'
            : total + ' of ' + qty + ' selected';
        }
        if (submit && !busy) {
          var ready = remaining === 0;
          submit.classList.toggle('is-pending', !ready);
          submit.textContent = ready ? submitLabel : 'Choose ' + remaining + ' more';
        }
      }
    }

    bundles.forEach(function (bundle) {
      bundle.addEventListener('click', function () {
        bundles.forEach(function (b) {
          var on = b === bundle;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        trimVariantsTo(cartQuantity());
        render();
      });
    });

    function trimVariantsTo(max) {
      var over = chosenTotal() - max;
      Object.keys(variantQty).reverse().forEach(function (id) {
        if (over <= 0) return;
        var cut = Math.min(over, variantQty[id]);
        variantQty[id] -= cut;
        over -= cut;
      });
    }

    variantRows.forEach(function (row) {
      var id = row.getAttribute('data-variant-id');
      function change(delta) {
        var next = (variantQty[id] || 0) + delta;
        if (next < 0) return;
        if (delta > 0 && chosenTotal() >= cartQuantity()) return;
        variantQty[id] = next;
        render();
      }
      var add = row.querySelector('[data-variant-add]');
      var inc = row.querySelector('[data-variant-increase]');
      var dec = row.querySelector('[data-variant-decrease]');
      if (add) add.addEventListener('click', function () { change(1); });
      if (inc) inc.addEventListener('click', function () { change(1); });
      if (dec) dec.addEventListener('click', function () { change(-1); });
    });

    // One-time mode: the bundles are locked behind an Autoship button, gifts show locked, and
    // the cart gets one unit of the one-time product (no EG rule, so no free units or gifts).
    function setOnceMode(on) {
      onceMode = on;
      root.classList.toggle('is-once', on);
      onceOnly.forEach(function (el) { el.hidden = !on; });
      if (tryOnce) tryOnce.hidden = on;
      if (autoshipNote) autoshipNote.hidden = on;
      showStatus('');
      render();
    }

    function lineItems(withAddon) {
      var items = [];
      if (onceMode) return onceVariant ? [{ id: Number(onceVariant), quantity: 1 }] : [];
      if (variantRows.length) {
        Object.keys(variantQty).forEach(function (id) {
          if (variantQty[id] > 0) items.push({ id: Number(id), quantity: variantQty[id] });
        });
      } else if (showerheadVariant) {
        items.push({ id: Number(showerheadVariant), quantity: cartQuantity() });
      }
      if (withAddon && addonVariant) {
        var addon = {
          id: Number(addonVariant),
          quantity: Math.max(1, Number(selectedBundle() && selectedBundle().getAttribute('data-addon-quantity')) || 1)
        };
        if (addonPlan) addon.selling_plan = Number(addonPlan);
        items.push(addon);
      }
      return items;
    }

    function showStatus(message) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
    }

    function addToCart(withAddon) {
      if (busy) return;
      if (!onceMode && variantRows.length && chosenTotal() !== cartQuantity()) {
        showStatus('Choose ' + (cartQuantity() - chosenTotal()) + ' more to continue.');
        return;
      }
      var items = lineItems(withAddon);
      if (!items.length) {
        showStatus('This product is not available right now.');
        return;
      }
      busy = true;
      showStatus('');
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding...';
      }
      fetch(cartAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart.');
            return data;
          });
        })
        .then(function () {
          return fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          window.dispatchEvent(new CustomEvent('muravai:open-cart', { detail: { cart: cart } }));
          // Same count as the cart drawer heading: leave out Warranty + Shipping Protection
          var badgeCount = cart.items.reduce(function (total, item) {
            var isProtection = item.handle === 'warranty-shipping-protection' || Number(item.variant_id) === 51670207267090;
            return isProtection ? total : total + item.quantity;
          }, 0);
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = String(badgeCount);
            el.hidden = badgeCount < 1;
          });
        })
        .catch(function (error) {
          showStatus(error.message || 'Could not add to cart. Please try again.');
        })
        .finally(function () {
          busy = false;
          if (submit) {
            submit.disabled = false;
            submit.textContent = submitLabel;
          }
          render();
        });
    }

    if (submit) submit.addEventListener('click', function () { addToCart(!onceMode); });
    if (tryOnce) tryOnce.addEventListener('click', function () { setOnceMode(true); });
    root.querySelectorAll('[data-autoship-back]').forEach(function (btn) {
      btn.addEventListener('click', function () { setOnceMode(false); });
    });

    render();
  }

  function initCountdown(el) {
    if (el.dataset.countdownReady) return;
    el.dataset.countdownReady = 'true';
    var mode = el.getAttribute('data-countdown-mode');
    var fixedEnd = Date.parse(el.getAttribute('data-countdown-end') || '');
    var after = el.getAttribute('data-countdown-after');
    var daysUnits = el.querySelectorAll('[data-days-unit]');
    var timer;

    function pad(n) { return String(n).padStart(2, '0'); }
    function set(selector, value) {
      var node = el.querySelector(selector);
      if (node) node.textContent = pad(value);
    }

    function tick() {
      var now = Date.now();
      var end;
      if (mode === 'fixed' && !isNaN(fixedEnd)) {
        end = fixedEnd;
      } else {
        var midnight = new Date();
        midnight.setHours(23, 59, 59, 999);
        end = midnight.getTime();
      }
      var diff = Math.max(0, end - now);
      if (diff === 0 && mode === 'fixed' && after === 'hide') {
        el.hidden = true;
        clearInterval(timer);
        return;
      }
      var days = Math.floor(diff / 86400000);
      daysUnits.forEach(function (unit) { unit.hidden = days === 0; });
      set('[data-d]', days);
      set('[data-h]', Math.floor((diff % 86400000) / 3600000));
      set('[data-m]', Math.floor((diff % 3600000) / 60000));
      set('[data-s]', Math.floor((diff % 60000) / 1000));
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function initStatRings(root) {
    var rings = Array.prototype.slice.call(root.querySelectorAll('[data-stat-ring]'));
    if (!rings.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    rings.forEach(function (ring) {
      ring.querySelector('.muravai-lp__stat-progress').style.strokeDasharray = '0 339.3';
      ring.querySelector('[data-stat-value]').textContent = '0';
    });

    function play(ring) {
      var progress = ring.querySelector('.muravai-lp__stat-progress');
      var value = ring.querySelector('[data-stat-value]');
      var target = Number(ring.getAttribute('data-percent')) || 0;
      var duration = 1600;
      var start = null;
      progress.style.strokeDasharray = ring.getAttribute('data-dash') + ' 339.3';
      function step(time) {
        if (start === null) start = time;
        var t = Math.min(1, (time - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        value.textContent = String(Math.round(target * eased));
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var ring = entry.target;
        var delay = rings.indexOf(ring) % 4 * 150;
        setTimeout(function () { play(ring); }, delay);
      });
    }, { threshold: 0.4 });

    rings.forEach(function (ring) { observer.observe(ring); });
  }

  function initCompareSlider(root) {
    root.querySelectorAll('[data-ba]').forEach(function (slider) {
      var range = slider.querySelector('[data-ba-range]');
      if (!range) return;
      var update = function () { slider.style.setProperty('--ba-pos', range.value + '%'); };
      range.addEventListener('input', update);
      update();
    });
  }

  function initMarquee(root) {
    var speed = 95; // px per second, matches the reference banner
    root.querySelectorAll('[data-marquee]').forEach(function (track) {
      var setSpeed = function () {
        var setWidth = track.scrollWidth / 4;
        if (setWidth > 0) track.style.animationDuration = (setWidth / speed) + 's';
      };
      setSpeed();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(setSpeed);
      window.addEventListener('resize', setSpeed);
    });
  }

  function initFilterAccordion(root) {
    root.querySelectorAll('[data-filter-accordion]').forEach(function (group) {
      group.addEventListener('toggle', function (event) {
        var opened = event.target;
        if (!opened || opened.tagName !== 'DETAILS' || !opened.open) return;
        group.querySelectorAll('details').forEach(function (item) {
          if (item !== opened) item.open = false;
        });
      }, true);
    });
  }
})();
